import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button, Badge } from '@nimbitlabs/ui';
import GlassCard from "@/components/landing/GlassCard";

const Pricing = () => {
  const plans = [
    {
      name: "Free",
      price: "R0",
      usd: "$0",
      period: "",
      description: "Perfect for getting started",
      features: [
        "Up to 3 team members",
        "Create up to 2 teams",
        "Deploy to 3 environments",
        "Monitor up to 5 services",
        "Basic health checks",
        "Community support",
      ],
      popular: false,
      cta: "Sign up",
    },
    {
      name: "Teams",
      price: "R299",
      usd: "~$18",
      period: "/month",
      annualPrice: "R3,229",
      usdAnnual: "~$195",
      annualPeriod: "/year",
      description: "Ideal for teams with growing service footprints",
      features: [
        "Up to 50 team members",
        "Unlimited teams",
        "Unlimited environments",
        "Unlimited services",
        "Advanced monitoring & alerts",
        "Automated runbooks & workflows",
        "Advanced incident management",
        "Full API access",
        "Custom integrations",
        "99.9% uptime SLA",
        "Dedicated support engineer",
        "Custom onboarding & training",
      ],
      popular: true,
      cta: "Sign up",
    },
  ];

  return (
    <section id="pricing" className="relative py-32">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold font-space mb-6">
            Simple, Transparent <span className="text-foreground">Pricing</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Choose the perfect plan for your team's needs. All plans include our core features with different
            levels of scale and support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto items-stretch">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className="relative transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
            >
              {plan.popular && (
                <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary text-primary-foreground px-4 py-1 z-10">
                  Most Popular
                </Badge>
              )}

              <GlassCard className="flex flex-col h-full p-8">
                <div className="text-center pb-8">
                  <h3 className="text-3xl font-bold font-space mb-2 text-foreground">{plan.name}</h3>
                  <div className="flex items-baseline justify-center gap-1 mt-6">
                    <span className="text-5xl font-bold text-primary">
                      {plan.price}
                    </span>
                    <span className="text-muted-foreground text-lg">{plan.period}</span>
                  </div>
                  {plan.usd && (
                    <p className="text-sm text-muted-foreground mt-1">
                      {plan.usd}{plan.period}
                    </p>
                  )}
                  <p className="text-muted-foreground mt-4 text-base">{plan.description}</p>
                </div>

                <div className="space-y-4 flex-grow">
                  {plan.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <Check className="h-4 w-4 text-primary flex-shrink-0" />
                      <span className="text-sm text-muted-foreground">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="pt-8 mt-auto">
                  <Button
                    asChild
                    className="w-full"
                    variant={plan.popular ? "default" : "outline"}
                    size="lg"
                  >
                    <Link to="/signup">
                      {plan.cta}
                    </Link>
                  </Button>
                </div>
              </GlassCard>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;